/**
 * 0.36.531 — React hook for subscribing to date/time format changes.
 *
 * Any component that renders formatted timestamps (formatDateTime /
 * formatDateOnly / etc.) can call `useFormatVersion()` at the top of
 * its render. When public settings load or the current user's
 * timezone changes, the returned version bumps and React re-renders
 * the component — which triggers a fresh call to the formatter that
 * reads the up-to-date module state.
 *
 * Uses useSyncExternalStore, the React 18+ standard for external
 * mutable stores.
 */

import { useSyncExternalStore } from 'react';
import { subscribeFormatChange, getFormatVersion } from '../utils/format';

export function useFormatVersion() {
  return useSyncExternalStore(
    subscribeFormatChange,
    getFormatVersion,
    getFormatVersion,
  );
}
